var _style, _path, _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182.7 44.5",
    style: {
      enableBackground: "new 0 0 182.7 44.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:#EBE8DE;}\r\n\t.st3{fill:#ACC88E;}\r\n\t.st4{fill:#2F3A4F;}\r\n\t.st5{fill:#FF4343;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,0L22.3,0C10,0,0,10,0,22.3l0,0c0,12.3,10,22.3,22.3,22.3l0,0c12.3,0,22.3-10,22.3-22.3l0,0 C44.5,10,34.6,0,22.3,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 22.3,
    cy: 22.3,
    r: 14.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 6.3,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 6.3,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 6.3,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 17.6,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 17.6,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 17.6,
    className: "st3",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 28.9,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 28.9,
    className: "st2",
    width: 9.3,
    height: 9.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 28.9,
    className: "st2",
    width: 9.3,
    height: 9.4
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,42.6C11.1,42.6,2,33.5,2,22.3S11.1,1.9,22.3,1.9S42.6,11,42.6,22.2S33.5,42.6,22.3,42.6z M22.3,6 C13.3,6,6,13.3,6,22.3s7.3,16.3,16.3,16.3s16.3-7.3,16.3-16.3S31.3,6,22.3,6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.3,9.7c-5.2,0-9.3,4.2-9.3,9.3c0,1.9,0.6,3.6,1.5,5.1L22.3,35l7.8-10.8c1-1.5,1.5-3.2,1.5-5.1 C31.6,13.9,27.5,9.7,22.3,9.7z M24.7,19.1c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4 C23.6,16.6,24.7,17.7,24.7,19.1z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.2,12.8h-4.7c-0.5,0-0.9,0.4-0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9h-4.2c-0.5,0-0.9-0.4-0.9-0.9v-5.1 c0-0.5-0.4-0.9-0.9-0.9H55c-0.5,0-0.9,0.4-0.9,0.9v17.6c0,0.5,0.4,0.9,0.9,0.9h4.7c0.5,0,0.9-0.4,0.9-0.9v-5.2 c0-0.5,0.4-0.9,0.9-0.9h4.2c0.5,0,0.9,0.4,0.9,0.9v5.2c0,0.5,0.4,0.9,0.9,0.9h4.7c0.5,0,0.9-0.4,0.9-0.9V13.7 C73.1,13.2,72.7,12.8,72.2,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,16.7c-5,0-8.5,3.6-8.5,7.9v0.1c0,4.3,3.5,7.8,8.5,7.8s8.5-3.6,8.5-7.9v-0.1 C91.6,20.3,88.1,16.7,83.2,16.7z M85.6,24.7c0,1.4-1,2.6-2.4,2.6s-2.5-1.2-2.5-2.7v-0.1c0-1.4,1-2.6,2.4-2.6S85.6,23.1,85.6,24.7 L85.6,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.9,16.7c-1.5,0-2.7,0.6-3.6,1.4c-0.4,0.3-1,0.1-1-0.4l0,0c0-0.3-0.3-0.6-0.6-0.6h-5.1 c-0.3,0-0.6,0.3-0.6,0.6v13.9c0,0.3,0.3,0.6,0.6,0.6h5.1c0.3,0,0.6-0.3,0.6-0.6v-7.3c0-1.3,0.9-2,1.8-2s1.7,0.7,1.7,2v7.3 c0,0.3,0.3,0.6,0.6,0.6h5.1c0.3,0,0.6-0.3,0.6-0.6v-9.4C109.1,18.8,107.1,16.7,103.9,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.3,17.1h-2.4c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3-0.2-0.5-0.5-0.5h-5.2c-0.3,0-0.5,0.2-0.5,0.5v2.7 c0,0.3-0.2,0.5-0.5,0.5H111c-0.3,0-0.5,0.2-0.5,0.5v3.8c0,0.3,0.2,0.5,0.5,0.5h0.7c0.3,0,0.5,0.2,0.5,0.5v4.7 c0,3.7,2,5.4,5.7,5.4c1.4,0,2.7-0.3,3.7-0.7c0.2-0.1,0.3-0.3,0.3-0.5v-3.7c0-0.4-0.3-0.6-0.7-0.5c-0.4,0.1-0.8,0.2-1.2,0.2 c-1,0-1.5-0.4-1.5-1.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h2.4c0.3,0,0.5-0.2,0.5-0.5v-3.8C121.8,17.3,121.5,17.1,121.3,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.2,17.5c0-0.4-0.3-0.7-0.7-0.7c-1.2,0.1-2.2,0.6-2.9,1.4c-0.4,0.4-1.1,0.2-1.1-0.5l0,0 c0-0.4-0.3-0.7-0.7-0.7h-4.9c-0.4,0-0.7,0.3-0.7,0.7v13.8c0,0.4,0.3,0.7,0.7,0.7h4.9c0.4,0,0.7-0.3,0.7-0.7v-3.2 c0-3.3,1.4-4.8,4.1-4.8c0.4,0,0.7-0.3,0.7-0.7v-5.3H134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.6,16.8c-2.6,0-4.5,0.4-6.2,1.1c-0.1,0-0.1,0.1-0.1,0.2l1,3.8c0,0.1,0.1,0.2,0.2,0.1 c1.3-0.5,2.5-0.8,4-0.8c1.9,0,2.8,0.8,2.8,2.2c0,0.1-0.1,0.2-0.2,0.2c-0.8-0.2-2.2-0.5-3.3-0.5c-3.5,0-5.7,1.7-5.7,4.7v0.1 c0,3,2,4.6,4.9,4.6c1.7,0,3-0.6,4-1.6c0.1-0.1,0.3,0,0.3,0.1v1c0,0.1,0.1,0.2,0.2,0.2h5.9c0.1,0,0.2-0.1,0.2-0.2v-8.4 c0-2.2-0.4-3.6-1.6-4.8C146.7,17.5,144.7,16.8,141.6,16.8z M143.4,26.6c0,1.4-0.8,2.3-1.9,2.3c-0.8,0-1.4-0.6-1.4-1.5v-0.1 c0-0.9,0.7-1.7,1.9-1.7c0.5,0,1,0.1,1.3,0.2c0.1,0,0.1,0.1,0.1,0.2L143.4,26.6L143.4,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,27.9l-2.7-1.5c-0.5-0.3-1-0.2-1.4,0.2c-0.5,0.5-1,0.8-1.8,0.8c-1.2,0-2.2-1.1-2.2-2.7v-0.1 c0-1.5,1-2.7,2.3-2.7c0.7,0,1.3,0.3,1.7,0.8c0.3,0.4,0.9,0.5,1.4,0.2l2.7-1.5c0.6-0.3,0.7-1.1,0.4-1.6c-1.3-1.9-3.4-3.1-6.2-3.1 c-4.9,0-8.2,3.7-8.2,7.9v0.1c0,4.2,3.3,7.8,7.9,7.8c3.1,0,5.2-1.2,6.6-3.1C165.7,28.9,165.6,28.2,165,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.5,30.6l-3.6-6.8c-0.2-0.4-0.2-0.8,0.1-1.2l3-3.9c0.5-0.7,0-1.7-0.8-1.7H177c-0.4,0-0.7,0.2-0.9,0.5 l-1,1.4c-0.6,0.9-1.9,0.4-1.9-0.6v-5.2c0-0.6-0.5-1.1-1.1-1.1H168c-0.6,0-1.1,0.5-1.1,1.1v18c0,0.6,0.5,1.1,1.1,1.1h4.1 c0.6,0,1.1-0.5,1.1-1.1V30c0-0.2,0.1-0.5,0.2-0.7l0,0c0.5-0.6,1.4-0.5,1.8,0.2l1.1,2.1c0.2,0.4,0.5,0.6,0.9,0.6h4.3 C182.4,32.2,182.9,31.3,182.5,30.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogob);
export default __webpack_public_path__ + "static/media/logob.5593b35b85c6c480e3d5153d10ed8b46.svg";
export { ForwardRef as ReactComponent };